import TariffSetToolsLimit from './TariffSetToolsLimit';

export default TariffSetToolsLimit;
